import React, {useEffect} from 'react'
import styled from 'styled-components';
import bg from "../Images/5.jpg"
import ReactTypingEffect from 'react-typing-effect';
import {FaFacebook, FaLinkedin, FaInstagram, FaGithub, FaTwitter} from "react-icons/fa"
// import cvpdf from "../Images/oguamanam-cynthia-frontend.png";
// import { bounce, flip, flipInX, flipInY, lightSpeedIn } from 'react-animations';
import AOS from 'aos'
import 'aos/dist/aos.css'


const Land1 = () => {

    useEffect(() => {
        AOS.init({duration:2000})
    }, []);
    
  const cvpdf = "https://kaleidoscopic-brigadeiros-d3012b.netlify.app/"

  const handleDownload = () => {
    const cvUrl = {cvpdf}; // Specify the path to your CV file

    // Create a link element
    const link = document.createElement('a');
    link.href = cvUrl;
    link.target = '_blank';
    link.download = 'oguamanam-cynthia-frontend.png'; // Specify the name for the downloaded file

    // Trigger a click event on the link to initiate the download
    link.click();
  };


  return (
    <Container>
        <Wrapper>
            <H1>I am Oguamanam Cynthia Chidera. </H1>
            <Span>Frontend Software Developer</Span>
            <Span><ReactTypingEffect speed={200} text={[ "Reactjs","Redux", "React Native", "Html & Css", "Javascript", "Github", "MERN", "Freelancer",]}/></Span>
            <Button onClick={handleDownload}>Download CV</Button>
            <Social data-aos="flip-up">
             <a href='https://web.facebook.com/cynthia.muna123' style={{cursor: "pointer"}}> <FaFacebook color='blue' fontSize="30px" /> </a>
             <a  href='https://github.com/CynthiaOguamanam/'>
              <FaGithub color='green' fontSize={"30px"} style={{cursor: "pointer"}}/>
             </a>
             <a href="https://www.linkedin.com/in/cynthia-oguamanam-504398251/">
              <FaLinkedin color='navy' fontSize={"30px"} style={{cursor: "pointer"}}/>
             </a>
             <a href='https://www.instagram.com/cynthia_oguamanam/'>
              <FaInstagram color='orangered' fontSize="30px" style={{cursor: "pointer"}}/>
             </a>
             <a href='https://twitter.com/CynthiaCodes1'>
              <FaTwitter color='white' fontSize="30px" style={{cursor: "pointer"}}/>
             </a>
            </Social>
        </Wrapper>
        <p style={{"--i": 1}}>
            {/* <p class="bubble"></p> */}
            <Bubble></Bubble>
        </p>
        <p style={{"--i": 2}}>
            <Bubble></Bubble>
        </p>
        <p style={{"--i": 3}}>
            <Bubble></Bubble>
        </p>
        <p style={{"--i": 4}}>
            <Bubble></Bubble>
        </p>
        <p style={{"--i": 5}}>
            <Bubble></Bubble>
        </p>
        <p style={{"--i": 6}}>
            <Bubble></Bubble>
        </p>
        <p style={{"--i": 7}}>
            <Bubble></Bubble>
        </p>
        <p style={{"--i": 8}}>
            <Bubble></Bubble>
        </p>
        <p style={{"--i": 9}}>
            <Bubble></Bubble>
        </p>
        <p style={{"--i": 10}}>
            <Bubble></Bubble>
        </p>
    </Container>
  )
};


export default Land1;


const Container = styled.div`
width: 100%;
height: 100vh;
background-image:url(${bg});
background-repeat: no-repeat;
background-size: cover;
background-position: center;
position: relative;
display: flex;
justify-content: center;
align-items: center;


p{
    position: absolute;
    display: block;
    width:20%;
    height: 20%;
    /* background: red; */
    animation: rotate 6s linear infinite;
    animation-delay: calc(0.15s * var(--i));

    @media Screen and (max-width: 768px){
        height: 13%;
        width: 7%;
    }
}


@keyframes rotate{
    0%{
        transform: rotate(0);
    }
    100%{
        transform:rotate(360deg)
    }
}

.bubble{
    position: absolute;
    width: 10px;
    height: 10px;
    background-color: tomato;
    border-radius: 100%;
    opacity: 0.6;
    animation: size 2s linear infinite;
    animation-delay: calc(0.15s * var(--i)) ;

    /* @media Screen and (max-width: 425px){
        opacity: 0.;
    } */
}

@keyframes size{
    0%{
        filter: hue-rotate(0deg);
    }
    90%{
        transform: scale(15);
        filter: hue-rotate(360deg);
    }
}


`;

const Bubble = styled.div`
  position: absolute;
    width: 10px;
    height: 10px;
    background-color: tomato;
    border-radius: 100%;
    opacity: 0.2;
    animation: size 3s linear infinite;
    animation-delay: calc(0.15s * var(--i)) ;

    @media Screen and (max-width: 425px){
        opacity: 0.14;
    }

    @keyframes size{
    0%{
        filter: hue-rotate(0deg);
    }
    90%{
        transform: scale(15);
        filter: hue-rotate(360deg);
    }
  }
`;
const Wrapper = styled.div`
width: 100%;
height: 100%;
background-color: black;
opacity: 70%;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
color: white;

@media Screen and (max-width: 768px){
  opacity: 90%;
}

`;

const H1 = styled.div`
    font-size: 55px;
    font-weight: bold;
    line-height: 80px;
    margin-left: -10px;
    color: transparent;
    /* transform: translate(-50%, -50%); */
    -webkit-text-stroke: 1px rgb(255, 255, 255);
    background-image: linear-gradient(45deg, white, white);
    background-repeat: no-repeat;
    -webkit-background-clip: text;
    background-position: -850px 0;
    animation: backcolor 4s linear infinite alternate;

    @keyframes backcolor {
      100%{
        background-position: 0 0;
    }
    }

@media Screen and (max-width: 768px){
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 45px;


}
@media Screen and (max-width: 425px){
  /* font-size: 25px; */
}
`;
const Span = styled.div`
font-size: 35px;
font-weight: bold;
text-align: center;
@media Screen and (max-width: 425px){
  font-size: 28px;
}
`;

const Button = styled.button`
margin-top: 30px;
padding: 14px 45px;
border-radius: 5px;
border: none;
cursor: pointer;
background-color: white;
font-size: 15px;
font-weight: bold;

`;
const Social = styled.div`
margin-top: 30px;
/* background-color: red; */
/* padding: 14px 45px; */
border-radius: 5px;
font-size: 15px;
font-weight: bold;
display: flex;
justify-content: space-between;
align-items: center;
width: 30%;
height: auto;
/* position: absolute; */
@media Screen and (max-width: 768px){
    width: 80%;
}
`;


// const AnimReact = styled.div`
// margin-top: 30px;
// padding: 14px 45px;
// border-radius: 5px;
// border: none;
// cursor: pointer;
// background-color: white;
// font-size: 15px;
// font-weight: bold;

// @media (prefers-reduced-motion: no-preference) {
// animation: App-logo-spin infinite 20s linear;
// }
// @keyframes App-logo-spin {
//   from {
//     transform: rotate(90degdeg);
//   }
//   to {
//     transform: rotate(45deg);
//   }
// }
// `;




// Design and create visually appealing and user-friendly websites
// - Collaborate with clients to understand their requirements and translate them into design concepts
// - Develop wireframes, prototypes, and mockups to present design ideas
// - Implement responsive design principles to ensure websites are optimized for all devices
// - Use HTML, CSS, and JavaSc ript to bring designs to life
// - Integrate third-party tools and APIs into websites, such as MailChimp for email marketing campaigns
// - Optimize website performance and ensure cross-browser compatibility
// - Collaborate with developers to implement back-end functionality and database integration
// - Stay up-to-date with industry trends and best practices in web design